import { useWizard } from "react-use-wizard";
import sellSteps from "../../sellSteps";
import {
  TKeyOfDataWizardSell,
  TStringKeysOfIFillDataWizardSell,
} from "../../..";
import { EDealRequestViewType } from "../../../../../../../shared/wizard/steps/types";
import ViewRealtorParticipationStep from "../../../../../../../shared/wizard/steps/viewRealtorParticipationStep";

interface IDoNotKnowPriceSwapStep_4 {
  onChange: (
    data: EDealRequestViewType,
    key: TStringKeysOfIFillDataWizardSell
  ) => void;
  data: EDealRequestViewType | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardSell[]) => void;
}

const DoNotKnowPriceSwapStep_4 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IDoNotKnowPriceSwapStep_4) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.doNotKnowPrice.swap.step_3);
    onReset(["viewRealtorParticipation"]);
  };

  const handleNexStep = () => {
    goToStep(sellSteps.doNotKnowPrice.swap.step_5);
  };

  return (
    <div>
      <ViewRealtorParticipationStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="sell"
      />
    </div>
  );
};

export default DoNotKnowPriceSwapStep_4;
